<template>
  <div class="search-bar theme-dark">
    <PrimeVueForm
      type="form"
      :actions="false"
      class="p-search-box-form col-12 col-md-10 mx-auto"
      @submit="handleSubmit"
    >
      <PrimeVueIconField>
        <PrimeVueInputText
          id="search-box-value"
          v-model="searchInputValue"
          type="search"
          rounded
          name="search-value"
          size="large"
          autocomplete="off"
          :placeholder="
            $textDictionary['searchSection.searchResults.searchPlaceholder'] ??
            ''
          "
          class="w-100 p-search-box"
        >
        </PrimeVueInputText>
        <PrimeVueInputIcon @click="handleSubmit">
          <icon :name="'action_bar_magnifier'" size="small" color="white" />
        </PrimeVueInputIcon>
      </PrimeVueIconField>
    </PrimeVueForm>
  </div>
</template>

<script lang="ts" setup>
import type { ITechnicalComponent } from '~/lib/ContentfulService';
import type { UseGlobalSearchOptions } from '~/composables/useGlobalSearch';
import { useGlobalSearch } from '~/composables/useGlobalSearch';
import { Icon } from '@hypercodestudio/basler-components';

type Props = {
  item: ITechnicalComponent;
};

const props = defineProps<Props>();

const { $textDictionary } = useNuxtApp();

const configuration = computed<UseGlobalSearchOptions>(
  () => props.item.fields.configuration ?? {}
);

const { handleSubmit, searchInputValue } = useGlobalSearch(configuration);
</script>
